import * as React from "react";
import { generateSrcSet, getQueryParamDelimiter } from "~/utils/image-utils";

export interface IResponsiveImageProps extends Omit<React.ImgHTMLAttributes<HTMLImageElement>, "src"> {
    className?: string;
    srcUrl: string;
    defaultSize: number;
    srcSetSizes?: number[];
    sizes?: string;
    ref?: React.Ref<HTMLImageElement>;
}

const ResponsiveImage: React.FC<IResponsiveImageProps> = React.forwardRef(
    ({ srcUrl, defaultSize, srcSetSizes, ...props }, ref: React.Ref<HTMLImageElement>) => {
        const src = `${srcUrl}${getQueryParamDelimiter(srcUrl)}w=${defaultSize}`;
        const srcSet = srcSetSizes ? generateSrcSet(srcSetSizes, srcUrl) : "";

        return <img ref={ref} src={src} srcSet={srcSet} {...props} loading="lazy" />;
    }
);

export default ResponsiveImage;
